import React from 'react'

import './ChipContainer.css'

export default function ChipContainer({ children }) {
    return (<div className='chip-container'>{ children }</div>)
}